module.exports = function(target, source, isTargetNew) {
  var key;
  var ret = {};

  if (isTargetNew) {
    for (key in target) {
      if (target.hasOwnProperty(key)) {
        ret[key] = target[key];
      }
    }
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        ret[key] = source[key];
      }
    }
    return ret;
    
  }else{
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
    return target;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-m-share/entries/util/extend.js
// module id = 302
// module chunks = 0 9